import api from '../client';

export const FAOService = {
  getPlans: () => api.get('/fao/plans'),
  createPlan: (data) => api.post('/fao/plans', data),
};
